import { useState } from "react";
import "./editorialForms.css";

const serviceTypes = [
  { id: "ride", name: "Corridas de Passageiros" },
  { id: "delivery", name: "Entregas" },
  { id: "freight", name: "Fretes" },
  { id: "moto", name: "Mototáxi" },
];

const vehicleTypes = [
  { id: "economy", name: "Econômico" },
  { id: "comfort", name: "Conforto" },
  { id: "premium", name: "Premium" },
  { id: "xl", name: "XL (6+ passageiros)" },
  { id: "moto", name: "Moto" },
  { id: "truck", name: "Caminhão" },
];

const features = [
  { id: "ac", name: "Ar Condicionado", icon: "❄️" },
  { id: "wifi", name: "Wi-Fi", icon: "📶" },
  { id: "music", name: "Sistema de Som", icon: "🎵" },
  { id: "child_seat", name: "Cadeirinha Infantil", icon: "👶" },
  { id: "pet_friendly", name: "Aceita Pets", icon: "🐾" },
  { id: "wheelchair", name: "Acessibilidade", icon: "♿" },
  { id: "luggage_space", name: "Espaço para Bagagem", icon: "🧳" },
];

export default function UberForm({ data, onChange }) {
  const handleServiceToggle = (serviceId) => {
    const currentServices = data?.services || [];
    const newServices = currentServices.includes(serviceId)
      ? currentServices.filter(s => s !== serviceId)
      : [...currentServices, serviceId];
    onChange({ ...data, services: newServices });
  };

  const handleFeatureToggle = (featureId) => {
    const currentFeatures = data?.features || [];
    const newFeatures = currentFeatures.includes(featureId)
      ? currentFeatures.filter(f => f !== featureId)
      : [...currentFeatures, featureId];
    onChange({ ...data, features: newFeatures });
  };

  return (
    <div className="editorial_form uber_form">
      {/* Informações do Motorista */}
      <div className="editorial_form_header">
        <h3>👤 Informações do Motorista</h3>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Nome Completo <span className="required">*</span></label>
          <input
            type="text"
            placeholder="Seu nome completo"
            value={data?.driverName || ""}
            onChange={(e) => onChange({ ...data, driverName: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>CNH</label>
          <input
            type="text"
            placeholder="Número da CNH"
            value={data?.driverLicense || ""}
            onChange={(e) => onChange({ ...data, driverLicense: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Anos de Experiência</label>
        <input
          type="number"
          placeholder="Ex: 5"
          value={data?.yearsOfExperience || ""}
          onChange={(e) => onChange({ ...data, yearsOfExperience: parseInt(e.target.value) || 0 })}
          min="0"
        />
      </div>

      {/* Informações do Veículo */}
      <div className="editorial_form_header">
        <h3>🚗 Informações do Veículo</h3>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Categoria do Veículo <span className="required">*</span></label>
          <select
            value={data?.vehicleType || ""}
            onChange={(e) => onChange({ ...data, vehicleType: e.target.value })}
          >
            <option value="">Selecione a categoria</option>
            {vehicleTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Capacidade de Passageiros</label>
          <input
            type="number"
            placeholder="Ex: 4"
            value={data?.vehicleCapacity || ""}
            onChange={(e) => onChange({ ...data, vehicleCapacity: parseInt(e.target.value) || 0 })}
            min="1"
            max="15"
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Marca</label>
          <input
            type="text"
            placeholder="Ex: Volkswagen"
            value={data?.vehicleBrand || ""}
            onChange={(e) => onChange({ ...data, vehicleBrand: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Modelo</label>
          <input
            type="text"
            placeholder="Ex: Gol"
            value={data?.vehicleModel || ""}
            onChange={(e) => onChange({ ...data, vehicleModel: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Ano</label>
          <input
            type="number"
            placeholder="Ex: 2020"
            value={data?.vehicleYear || ""}
            onChange={(e) => onChange({ ...data, vehicleYear: parseInt(e.target.value) || 0 })}
            min="1990"
            max={new Date().getFullYear() + 1}
          />
        </div>

        <div className="editorial_form_section">
          <label>Cor</label>
          <input
            type="text"
            placeholder="Ex: Prata"
            value={data?.vehicleColor || ""}
            onChange={(e) => onChange({ ...data, vehicleColor: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Placa</label>
          <input
            type="text"
            placeholder="ABC-1234"
            value={data?.vehiclePlate || ""}
            onChange={(e) => onChange({ ...data, vehiclePlate: e.target.value.toUpperCase() })}
          />
        </div>
      </div>

      {/* Serviços Oferecidos */}
      <div className="editorial_form_header">
        <h3>🎯 Serviços Oferecidos</h3>
      </div>

      <div className="editorial_form_section">
        <label>Selecione os serviços que você oferece <span className="required">*</span></label>
        <div className="checkbox_grid">
          {serviceTypes.map((service) => (
            <label key={service.id} className="checkbox_item">
              <input
                type="checkbox"
                checked={(data?.services || []).includes(service.id)}
                onChange={() => handleServiceToggle(service.id)}
              />
              <span>{service.name}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Preços */}
      <div className="editorial_form_header">
        <h3>💰 Tarifas e Preços</h3>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tarifa Base (R$) <span className="required">*</span></label>
          <input
            type="number"
            placeholder="5.00"
            value={data?.baseFare || ""}
            onChange={(e) => onChange({ ...data, baseFare: parseFloat(e.target.value) || 0 })}
            min="0"
            step="0.01"
          />
          <small>Valor inicial da corrida</small>
        </div>

        <div className="editorial_form_section">
          <label>Por Km (R$) <span className="required">*</span></label>
          <input
            type="number"
            placeholder="2.50"
            value={data?.pricePerKm || ""}
            onChange={(e) => onChange({ ...data, pricePerKm: parseFloat(e.target.value) || 0 })}
            min="0"
            step="0.01"
          />
          <small>Valor por quilômetro rodado</small>
        </div>

        <div className="editorial_form_section">
          <label>Por Minuto (R$) <span className="required">*</span></label>
          <input
            type="number"
            placeholder="0.50"
            value={data?.pricePerMin || ""}
            onChange={(e) => onChange({ ...data, pricePerMin: parseFloat(e.target.value) || 0 })}
            min="0"
            step="0.01"
          />
          <small>Valor por minuto de corrida</small>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Tarifa Mínima (R$)</label>
        <input
          type="number"
          placeholder="8.00"
          value={data?.minimumFare || ""}
          onChange={(e) => onChange({ ...data, minimumFare: parseFloat(e.target.value) || 0 })}
          min="0"
          step="0.01"
        />
        <small>Valor mínimo cobrado por corrida</small>
      </div>

      {/* Área de Cobertura */}
      <div className="editorial_form_header">
        <h3>📍 Área de Cobertura</h3>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Cidade <span className="required">*</span></label>
          <input
            type="text"
            placeholder="Ex: São Paulo"
            value={data?.city || ""}
            onChange={(e) => onChange({ ...data, city: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Estado</label>
          <input
            type="text"
            placeholder="Ex: SP"
            value={data?.state || ""}
            onChange={(e) => onChange({ ...data, state: e.target.value.toUpperCase() })}
            maxLength="2"
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Descrição da Área de Cobertura</label>
        <textarea
          placeholder="Ex: Atendo toda a zona sul e centro da cidade"
          value={data?.coverage || ""}
          onChange={(e) => onChange({ ...data, coverage: e.target.value })}
          rows={2}
          maxLength={200}
        />
      </div>

      <div className="editorial_form_section">
        <label>Raio de Cobertura (km)</label>
        <input
          type="number"
          placeholder="Ex: 20"
          value={data?.coverageRadius || ""}
          onChange={(e) => onChange({ ...data, coverageRadius: parseInt(e.target.value) || 0 })}
          min="1"
        />
        <small>Distância máxima que você atende a partir do seu ponto base</small>
      </div>

      {/* Características do Veículo */}
      <div className="editorial_form_header">
        <h3>✨ Características do Veículo</h3>
      </div>

      <div className="editorial_form_section">
        <label>Recursos e Comodidades</label>
        <div className="checkbox_grid">
          {features.map((feature) => (
            <label key={feature.id} className="checkbox_item feature_item">
              <input
                type="checkbox"
                checked={(data?.features || []).includes(feature.id)}
                onChange={() => handleFeatureToggle(feature.id)}
              />
              <span>
                <span className="feature_icon">{feature.icon}</span>
                {feature.name}
              </span>
            </label>
          ))}
        </div>
      </div>

      {/* Descrição */}
      <div className="editorial_form_header">
        <h3>📝 Descrição do Serviço</h3>
      </div>

      <div className="editorial_form_section">
        <label>Sobre você e seu serviço</label>
        <textarea
          placeholder="Conte aos passageiros sobre sua experiência, diferenciais do seu serviço, horários preferenciais, etc."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          rows={4}
          maxLength={500}
        />
        <small>{(data?.description || "").length}/500 caracteres</small>
      </div>

      {/* Disponibilidade */}
      <div className="editorial_form_header">
        <h3>🕒 Disponibilidade</h3>
      </div>

      <div className="editorial_form_section">
        <label className="checkbox_item">
          <input
            type="checkbox"
            checked={data?.available !== false}
            onChange={(e) => onChange({ ...data, available: e.target.checked })}
          />
          <span>Estou disponível para aceitar corridas agora</span>
        </label>
      </div>

      {/* Informações de Cálculo */}
      {data?.baseFare && data?.pricePerKm && data?.pricePerMin && (
        <div className="fare_preview">
          <h4>💡 Exemplo de Cálculo</h4>
          <div className="fare_example">
            <p><strong>Corrida de 10 km em 20 minutos:</strong></p>
            <ul>
              <li>Tarifa base: R$ {data.baseFare.toFixed(2)}</li>
              <li>Distância: R$ {(10 * data.pricePerKm).toFixed(2)} (10 km)</li>
              <li>Tempo: R$ {(20 * data.pricePerMin).toFixed(2)} (20 min)</li>
              <li>Taxa de serviço (15%): R$ {((data.baseFare + (10 * data.pricePerKm) + (20 * data.pricePerMin)) * 0.15).toFixed(2)}</li>
              <li className="fare_total">
                <strong>Total: R$ {((data.baseFare + (10 * data.pricePerKm) + (20 * data.pricePerMin)) * 1.15).toFixed(2)}</strong>
              </li>
            </ul>
            <small>Você receberá: R$ {((data.baseFare + (10 * data.pricePerKm) + (20 * data.pricePerMin))).toFixed(2)} (85% do total)</small>
          </div>
        </div>
      )}
    </div>
  );
}
